import { Button, Chip, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DialogWrapper from '../../../components/core-ui/DialogWrapper'
import { categoryService } from '../../../services/categoryService'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { toast } from 'react-toastify'

const KeywordList = ({ keywords, selectedKeywords, onSelect }) => {
  const { user } = useAuthContext()
  const [category, setCategory] = useState('')
  const [description, setDescription] = useState('')
  const [openCreateDialog, setOpenCreateDialog] = useState(false)

  const [categories, setCategories] = useState([...keywords])

  useEffect(() => {
    setCategories(keywords)
  }, [keywords])

  const handleClick = (id) => {
    const selected = categories.find((it) => it.id == id)
    if (selected) {
      onSelect(selected)
    } else {
      setOpenCreateDialog(true)
    }
  }

  const createCategory = async () => {
    const sequence = categories.length + 2
    try {
      const insertedCategory = await categoryService.createCategory(user, {
        name: category,
        description,
        sequence,
      })
      setCategories([...categories, { id: insertedCategory.id, value: insertedCategory.name }])
      toast.success(`Added new category "${insertedCategory.name}"`)
      setOpenCreateDialog(false)
      setCategory('')
      setDescription('')
    } catch (error) {
      toast.error(`Something went wrong!`)
    }
  }

  return (
    <div style={{ display: 'flex', columnGap: 8, rowGap: 8, margin: '16px 8px', flexWrap: 'wrap' }}>
      {[...categories, { id: 1000, value: 'Add New +' }].map((keyword) => (
        <Chip label={keyword.value} key={keyword.id} onClick={() => handleClick(keyword.id)}></Chip>
      ))}
      {openCreateDialog && (
        <DialogWrapper
          heading={'Create Category'}
          open={openCreateDialog}
          onClose={() => setOpenCreateDialog(false)}
          actions={
            <>
              <Button
                variant="contained"
                onClick={() => {
                  setOpenCreateDialog(false)
                  setCategory('')
                  setDescription('')
                }}
              >
                Cancel
              </Button>
              <Button color="primary" variant="contained" onClick={createCategory}>
                Save
              </Button>
            </>
          }
        >
          <TextField
            size="small"
            style={{ margin: '8px 0px' }}
            id="outlined"
            label="Write Name"
            placeholder="Write Name"
            sx={{ width: '100%' }}
            onChange={(e) => setCategory(e.target.value)}
            value={category}
          />
          <TextField
            size="small"
            style={{ margin: '8px 0px' }}
            id="outlined"
            label="Write Description"
            placeholder="Write Description"
            sx={{ width: '100%' }}
            onChange={(e) => setDescription(e.target.value)}
            value={description}
          />
        </DialogWrapper>
      )}
    </div>
  )
}

export default KeywordList
